import React, { useState } from "react";

type StatCardProps = {
  label: string;
  value: number | string;
  color: "text-green-600" | "text-red-600" | "text-cyan-600";
};

type StatData = {
  id: string;
  label: string;
  value: number | string;
  color: "text-green-600" | "text-red-600" | "text-cyan-600";
};

// Dummy data - exact values from original code
const dummyData: StatData[] = [
  {
    id: "live-screens",
    label: "Live screens",
    value: "10",
    color: "text-green-600",
  },
  {
    id: "inactive-screens",
    label: "Inactive screens",
    value: "04",
    color: "text-red-600",
  },
  {
    id: "total-screens",
    label: "Total screens",
    value: "14",
    color: "text-cyan-600",
  },
];

const StatCard: React.FC<StatCardProps> = ({ label, value, color }) => (
  <div className="flex-1 min-w-0 h-16 sm:h-[68px] md:h-[70px] lg:h-[70px] xl:h-[62px] 2xl:h-[64px] 3xl:h-[82px] px-[16px] md:px-[24px] xl:px-[32px] 2xl:px-[40px] 3xl:px-[48px] py-3 sm:py-4 rounded-xl bg-white shadow-[0px_2px_24px_0px_rgba(0,0,0,0.05)] flex items-center">
    <div className="w-full h-full flex justify-between items-center">
      <span className="text-gray-700 text-sm sm:text-base 3xl:text-lg font-medium truncate pr-4">
        {label}
      </span>
      <span
        className={`text-xl sm:text-2xl 3xl:text-3xl font-bold ${color} flex-shrink-0`}
      >
        {value}
      </span>
    </div>
  </div>
);

const StatCardScreen: React.FC = () => {
  const [statsData] = useState<StatData[]>(dummyData);

  return (
    <div className="flex flex-col sm:flex-row gap-4 w-full max-w-full overflow-hidden px-4 sm:px-4 lg:px-4 xl:px-5 2xl:px-5 3xl:px-6 py-4 sm:py-4 md:py-4 lg:py-4 xl:py-4 2xl:py-4 3xl:py-[30px]">
      {statsData.map((stat) => (
        <StatCard
          key={stat.id}
          label={stat.label}
          value={stat.value}
          color={stat.color}
        />
      ))}
    </div>
  );
};

export default StatCardScreen;
